import React from 'react';
import classNames from 'classnames';
import { ButtonToolbar, Button } from 'bootstrap';
import CuesheetTrackingActions from 'flux/actions/cuesheet/CuesheetTrackingActions';
import RoleHelper from 'shared/lib/role';

/**
 * Item Cell component (compact)
 *
 */
export default React.createClass({
  displayName: 'TrackingUserPill',

  propTypes: {
    user: React.PropTypes.object,
    trackedUsers: React.PropTypes.array,
  },

  contextTypes: {
    router: React.PropTypes.object.isRequired,
    user: React.PropTypes.object.isRequired,
  },

  render() {
    const trackableUsers = this.props.trackedUsers;

    if (!this.props.trackedUsers) return null;

    let itemNodes = trackableUsers
      .map((firstLast, id) => {
        return (
          <Button onClick={() => this._handleTrackingSwitchClick(id)}>
            {firstLast}
          </Button>
        );
      })
      .take(1);

    const { eventId } = this.context.router.state.params,
      user = this.context.user;

    let classes = classNames('cs-item-cell-trackable-users', {
      'cs-item-cell-trackable-users-hover': RoleHelper.hasEventShowCallerRole(
        user,
        eventId,
      ),
    });

    return <ButtonToolbar className={classes}>{itemNodes}</ButtonToolbar>;
  },

  _handleTrackingSwitchClick(id) {
    CuesheetTrackingActions.selectTrackableUser(id);
    CuesheetTrackingActions.toggleTrackingEnabled();
  },
});
